export interface DescriptionSpec {
  label: string;
  value: string;
}

const SPEC_LINE = /^\s*[*•-]?\s*([^:]+?)\s*:\s*(.+?)\s*$/;

/**
 * Splits a free-text description into "Label: value" spec lines and the remaining text.
 * Used configs are entered with their characteristics typed into the description.
 */
export const splitDescriptionSpecs = (description = ''): { specs: DescriptionSpec[]; text: string } => {
  const specs: DescriptionSpec[] = [];
  const textLines: string[] = [];

  description.split('\n').forEach(line => {
    const match = line.match(SPEC_LINE);
    if (match) {
      specs.push({ label: match[1], value: match[2] });
    } else if (line.trim()) {
      textLines.push(line.trim());
    }
  });

  return { specs, text: textLines.join('\n') };
};
